import React from 'react'
import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '../button';
import { i18n, getLocale } from 'core/i18n';
import Tools from 'core/tools';
import './unknow404.css';
import bgimg1 from 'assets/images/bg-img-1.svg';
import bgimg2 from 'assets/images/bg-img-2.svg';

class Unknow404 extends Component {
  render() {
    return (
      <div className='page-404-content'>
        <img className='page-404-bg-left-top' alt='' src={bgimg1} />
        <img className='page-404-bg-right-bottom' alt='' src={bgimg2} />
        <div>
          <div>
            <span>page </span>
            <span>not found</span>
          </div>
          <div>
          </div>
          <div className='page-404-footer-button'>
            <Button
              className={'primary-button'}
              onClick={() => {
                this.props.history.push(Tools.generateLocaleUrl(getLocale(), '/Login'));
              }}
            >
              {i18n('re-login')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Unknow404);